export const TOKEN_COOKIE_KEY = "token";
